<template>
  <div class="wrapper">
    <div v-if="environmentLabel" style="background-color: rgb(254, 200, 53);
				position: fixed;
				top: 0;
				z-index: 9999;
				width: 100%;
				text-align: center;
				color: #fff;">
      {{ environmentLabel }}
    </div>
    <notifications></notifications>
    <!-- <template slot="links-header"> -->
    <!-- </template> -->
    <side-bar>
      <template slot="links">
        <div class="mt-3">
          <h3 class="text-uppercase text-center p-2 text-muted">Invinity V2</h3>
        </div>
        <sidebar-item v-if="checkAccess(['invinity__dashboard'])" :link="{ name: 'Dashboard', icon: 'fa fa-chart-line' }">
          <sidebar-item :link="{ name: 'LMS Dashboard', path: '/dashboard/lms' }" />
        </sidebar-item>
        <sidebar-item v-if="checkAccess(['invinity__all__customer', 'invinity__pending__acceptance', 'invinity__pending__proposal'])" :link="{ name: 'Customer List', icon: 'fa fa-user' }">
          <sidebar-item v-if="checkAccess(['invinity__pending__acceptance'])" :link="{ name: 'Pending Acceptance', path: '/customers-list/pending-acceptance' }" />
          <sidebar-item v-if="checkAccess(['invinity__pending__proposal'])" :link="{ name: 'Pending Proposal', path: '/customers-list/pending-proposal' }" />
          <sidebar-item v-if="checkAccess(['invinity__all__customer'])" :link="{ name: 'All Customer', path: '/customers-list/all-customer' }" />
        </sidebar-item>

        <sidebar-item v-if="checkAccess(['invinity__cl__case', 'invinity__cl__collection', 'invinity__cl__disbursement'])" :link="{ name: 'Credit Loan Case', icon: 'fa fa-money-check' }">
          <sidebar-item v-if="checkAccess(['invinity__cl__case'])" :link="{ name: 'Case', path: '/credit-loan-case/all-case' }" />
          <sidebar-item v-if="checkAccess(['invinity__cl__collection'])" :link="{ name: 'Disbursement', path: '/credit-loan-case/all-case-disbursement' }" />
          <sidebar-item v-if="checkAccess(['invinity__cl__disbursement'])" :link="{ name: 'Collection', path: '/credit-loan-case/all-case-collection' }" />
        </sidebar-item>

        <sidebar-item v-if="checkAccess(['invinity__reporting'])" :link="{ name: 'Reporting', icon: 'fa fa-chart-line', path: '/reporting' }" />

        <sidebar-item v-if="checkAccess(['invinity__funds__management'])" :link="{ name: 'Funds Management (NOT READY)', icon: 'ni ni-sound-wave' }">
          <sidebar-item :link="{ name: 'Analysis', path: '/funds_management/analysis' }" />
          <sidebar-item :link="{ name: 'Investor Profile', path: '/funds_management/investors_profile' }" />
          <sidebar-item :link="{ name: 'Referral Fee', path: '/funds_management/referral_fee' }" />
          <sidebar-item :link="{ name: 'Cashflow', path: '/funds_management/cashflow' }" />
          <sidebar-item :link="{ name: 'Payment Approval', path: '/funds_management/payment_approval' }" />
        </sidebar-item>

        <sidebar-item v-if="checkAccess(['invinity__setup'])" :link="{ name: 'Setup', icon: 'ni ni-settings-gear-65', }">
          <sidebar-item :link="{ name: 'User (WIP)', path: '/setup/users' }" />
          <sidebar-item :link="{ name: 'All Settings', path: '/setup/settings' }" />
          <sidebar-item :link="{ name: 'All Templates', path: '/setup/templates' }" />
          <sidebar-item :link="{ name: 'All Statuses', path: '/setup/statuses' }" />
          <!-- <sidebar-item :link="{ name: 'Variable Expense', path: '/setup/variable_expense' }"/> -->
        </sidebar-item>
        <!-- 
        <sidebar-item :link="{
                  name: 'Examples',
                  icon: 'ni ni-ungroup text-orange'
                  }">
          <sidebar-item :link="{ name: 'Pricing', path: '/pricing' }"/>
          <sidebar-item :link="{ name: 'Login', path: '/login' }"/>
          <sidebar-item :link="{ name: 'Register', path: '/register' }"/>
          <sidebar-item :link="{ name: 'Lock', path: '/lock' }"/>
          <sidebar-item :link="{ name: 'Timeline', path: '/pages/timeline' }"/>
          <sidebar-item :link="{ name: 'Profile', path: '/pages/user' }"/>


        </sidebar-item>
        <sidebar-item :link="{
                  name: 'Components',
                  icon: 'ni ni-ui-04 text-info'
                }">
          <sidebar-item :link="{ name: 'Buttons', path: '/components/buttons' }"/>
          <sidebar-item :link="{ name: 'Cards', path: '/components/cards' }"/>
          <sidebar-item :link="{ name: 'Grid', path: '/components/grid-system' }"/>
          <sidebar-item :link="{ name: 'Notifications', path: '/components/notifications' }"/>
          <sidebar-item :link="{ name: 'Icons', path: '/components/icons' }"/>
          <sidebar-item :link="{ name: 'Typography', path: '/components/typography' }"/>
          <sidebar-item :link="{ name: 'Nested Sorting', path: '/components/nested-sorting' }"/>

          <sidebar-item :link="{ name: 'Multi Level' }">
            <sidebar-item :link="{ name: 'Third level menu', path:'#!' }"/>
            <sidebar-item :link="{ name: 'Just another link', path:'#a' }"/>
            <sidebar-item :link="{ name: 'One last link', path:'#b' }"/>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
                        name: 'Forms',
                        icon: 'ni ni-single-copy-04 text-pink'
                      }">
          <sidebar-item :link="{ name: 'Elements', path: '/forms/elements' }"/>
          <sidebar-item :link="{ name: 'Components', path: '/forms/components' }"/>
          <sidebar-item :link="{ name: 'Validation', path: '/forms/validation' }"/>
        </sidebar-item>
        <sidebar-item :link="{
                        name: 'Tables',
                        icon: 'ni ni-align-left-2 text-default'
                      }">
          <sidebar-item :link="{ name: 'Tables', path: '/tables/regular' }"/>
          <sidebar-item :link="{ name: 'Sortable', path: '/tables/sortable' }"/>
          <sidebar-item :link="{ name: 'Paginated Tables', path: '/tables/paginated' }"/>
        </sidebar-item>
        <sidebar-item :link="{
                        name: 'Maps',
                        icon: 'ni ni-map-big text-primary'
                      }">
          <sidebar-item :link="{ name: 'Google', path: '/maps/google' }"/>
          <sidebar-item :link="{ name: 'Vector', path: '/maps/vector' }"/>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Widgets',
            icon: 'ni ni-archive-2 text-green',
            path: '/widgets'
          }">
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Charts',
            icon: 'ni ni-chart-pie-35 text-info',
            path: '/charts'
          }">
        </sidebar-item> -->


      </template>

      <!-- <template slot="links-after">
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">Documentation</h6>
        <b-nav class="navbar-nav mb-md-3">
          <b-nav-item
               href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
               >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/charts/argon-dashboard">
              <i class="ni ni-chart-pie-35"></i>
              <b-nav-text class="p-0">Plugins</b-nav-text>
          </b-nav-item>
        </b-nav>
      </template> -->
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <!-- Drawer for Messaging -->
        <MessagingDrawer ref="messaging_drawer_section" />
        <SmsDrawer ref="sms_drawer_section" />
        <PreviewModal ref="preview_file_modal"></PreviewModal>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      <LoadingWidget />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import MessagingDrawer from '@/views/Messaging/MessagingDrawer'
import SmsDrawer from '@/views/Sms/SmsDrawer'
import PreviewModal from '@/components/Modal/PreviewModal';
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import LoadingWidget from '@/views/Widgets/LoadingWidget'
import { FadeTransition } from 'vue2-transitions';
import { getUserInfo } from '@/assets/js/config.js'
import { helperFunctionMixin } from '@/assets/js/httpImports.js'

import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'


export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    LoadingWidget,
    FadeTransition,
    MessagingDrawer,
    SmsDrawer,
    PreviewModal
  },
  mixins: [helperFunctionMixin],
  data() {
    return {
      loginUser: getUserInfo(),
      demo: process.env.DEMO || true,
    }
  },
  created() {
    chatEventBus.$on('show-message-drawer', this.showMessageDrawer);
    chatEventBus.$on('show-sms-drawer', this.showSmsDrawer);
    gEventBus.$on('show-preview-modal', this.showPreviewModal);
    if (_gAuth.isLogin()) {
      this.fetchConstantData()
    }
  },
  mounted() {
    this.initScrollbar()
  },
  beforeDestroy() {
    chatEventBus.$off('show-message-drawer', this.showMessageDrawer)
    chatEventBus.$off('show-sms-drawer', this.showSmsDrawer);
    gEventBus.$off('show-preview-modal', this.showPreviewModal);
  },
  computed: {
    environmentLabel() {
      if (!_gAuth.appIsDemo()) return '';

      if (typeof window === 'undefined') {
        return '';
      }
      const hostname = window.location.hostname; // Log the hostname for debugging
      if (hostname.includes('uat')) {
        return 'UAT Environment';
      } else if (hostname.includes('demo')) {
        return 'DEMO Environment';
      } else if (hostname.includes('localhost')) {
        return 'LOCAL Environment';
      }
      return '';
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['fetchConstantData']),
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
    showMessageDrawer(event) {
      // console.log(event);
      // console.log("EVENT");
      if (!_gHlp.isEmpty(event)) {
        this.$refs.messaging_drawer_section.viewMessagingDrawer(event)
      }
    },
    showSmsDrawer(event) {
      // console.log(event);
      // console.log("EVENT");
      if (!_gHlp.isEmpty(event)) {
        this.$refs.sms_drawer_section.viewSmsDrawer(event)
      }
    },
    showPreviewModal(event) {
      // console.log(event);
      // console.log("EVENT");
      if (!_gHlp.isEmpty(event)) {
        this.$refs.preview_file_modal.preview(event.url, event.original_filename);
      }
    },
  },
}
</script>
<style scoped lang="scss">
.navbar-header {
  padding: 0.675rem 1.5rem !important;
}

.g-sidenav-pinned .sidenav .navbar-header {
  display: block;
}

.sidenav .navbar-header {
  padding: 1.5rem;
  display: none;
}
</style>
